import dayjs from 'dayjs';
import React, { FunctionComponent, memo } from 'react';

import { nFormatter, numberWithCommas } from '../../../utils/common';
import { isDefined } from '../../../utils/guards';
import Typography from '../typography';
import { CellType } from '.';
import CompDot from './table-icons/compDot';
import FileIcon from './table-icons/fileIcon';
import NRDName from './table-icons/nrd-name';
import TabArea from './table-icons/tabArea';

interface IProps {
  rowItem: any;
  cellType?: CellType;
}

const TableCell: FunctionComponent<IProps> = ({
  rowItem,
  cellType = undefined,
}) => {
  if (!isDefined(rowItem)) {
    return null;
  }

  if (rowItem === Infinity) {
    return <Typography className="text-gray-100">–</Typography>;
  }

  switch (cellType) {
    case 'currency':
      return (
        <Typography className="text-gray-100">{`$${numberWithCommas(
          rowItem
        )}`}</Typography>
      );
    case 'percentage':
      return <Typography className="text-gray-100">{`${rowItem}%`}</Typography>;
    case 'circle':
      return <TabArea num={rowItem} />;
    case 'comp-dot':
      return <CompDot compType={rowItem} />;
    case 'react-node':
      return rowItem;
    case 'file-type':
      return <FileIcon fileType={rowItem} />;
    case 'number-whole': {
      return (
        <Typography className="text-gray-100">{nFormatter(rowItem)}</Typography>
      );
    }
    case 'number-1': {
      return (
        <Typography className="text-gray-100">
          {nFormatter(rowItem, 1)}
        </Typography>
      );
    }
    case 'date':
      return (
        <Typography className="text-gray-100">
          {dayjs(rowItem).format('MM-DD-YYYY')}
        </Typography>
      );
    case 'nrd-name':
      return <NRDName item={rowItem} />;
    default:
      return (
        <Typography className="break-words text-gray-100">{rowItem}</Typography>
      );
  }
};

export default memo(TableCell);
